<template lang="html">

<div class="modal modal-right small fade"
     id="stat-modal-consult"
     tabindex="-1"
     role="dialog"
     aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Statistiques de la journée<br>
                    <span class="text-muted small"> Tous les consultants </span>
                </h5>

                <button type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <div class="row g-2 justify-content-between">
                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-success sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-inbox text-white lh-1 confetti"></i>
                                </div>
                            </div>
                            
                            <div class="col-auto sh-6 ps-2 d-flex justify-content-center align-items-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.received}} avis
                                        </div>
                                        <div class="text-muted small">Reçus</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-alternate sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-x-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.impossible}} avis
                                        </div>
                                        <div class="text-muted small">Impossible</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-warning bg-gradient sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-pencil text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.redacted}} avis
                                        </div>
                                        <div class="text-muted small">Rédigés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-info sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-eye text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.published}} avis
                                        </div>
                                        <div class="text-muted small">Publiés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-danger sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-patch-exclamation text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.signaled}} avis
                                        </div>
                                        <div class="text-muted small">Signalés</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <div class="h-100 row g-0 align-items-center">
                            <div class="col-auto">
                                <div class="bg-warning sw-5 sh-5 rounded-md d-flex justify-content-center align-items-center">
                                    <i class="icon-20 bi-question-octagon text-white lh-1"></i>
                                </div>
                            </div>
                            <div class="col sh-6 ps-2 d-flex flex-column justify-content-center">
                                <div class="row g-0">
                                    <div class="col-auto">
                                        <div class="cta-3 text-primary">
                                            {{stats.today.info_needed}} <small>demandes</small>
                                        </div>
                                        <div class="text-muted small">d'infos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0">
                <div class="btn-group" role="group">
                    <button class="btn btn-outline-primary"
                            type="button"
                            data-bs-dismiss="modal"
                            aria-label="Close">Fermer
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>

export default {
  name: 'StatsTeam',
  props: {
    consultant_uid: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    user() {
      return {
        fullname: this.$store.state.profile &&
                  this.$store.state.profile.data &&
                  this.$store.state.profile.data.fullname
                  ? this.$store.state.profile.data.fullname
                  : ""
      };
    },
    stats() {
      const initialStats = {
        today: {
          received: 0,
          impossible: 0,
          redacted: 0,
          published: 0,
          signaled: 0,
          info_needed: 0
        },
        last7days: {
          received: 0,
          impossible: 0,
          redacted: 0,
          published: 0,
          signaled: 0,
          info_needed: 0
        },
        last30days: {
          received: 0,
          impossible: 0,
          redacted: 0,
          published: 0,
          signaled: 0,
          info_needed: 0
        }
      };

      const statsArray = this.$store.state.stats || [];
      const self = this;

      return statsArray.reduce(function(acc, current) {
        if (self.consultant_uid !== null && self.consultant_uid !== current.consultant_id) {
          return acc;
        }

        acc.today.received += current.today_recived_count || 0;
        acc.today.impossible += current.today_impossible_count || 0;
        acc.today.redacted += current.today_written_count || 0;
        acc.today.published += current.today_published_count || 0;
        acc.today.signaled += current.today_signaled_count || 0;
        acc.today.info_needed += current.today_information_needed_count || 0;

        acc.last7days.received += current.seven_day_recived_count || 0;
        acc.last7days.impossible += current.seven_day_impossible_count || 0;
        acc.last7days.redacted += current.seven_day_written_count || 0;
        acc.last7days.published += current.seven_day_published_count || 0;
        acc.last7days.signaled += current.seven_day_signaled_count || 0;
        acc.last7days.info_needed += current.seven_day_information_needed_count || 0;

        acc.last30days.received += current.thirty_day_recived_count || 0;
        acc.last30days.impossible += current.thirty_day_impossible_count || 0;
        acc.last30days.redacted += current.thirty_day_written_count || 0;
        acc.last30days.published += current.thirty_day_published_count || 0;
        acc.last30days.signaled += current.thirty_day_signaled_count || 0;
        acc.last30days.info_needed += current.thirty_day_information_needed_count || 0;

        return acc;
      }, initialStats);
    }
  },
  mounted() {
    // rien à faire
  }
}
</script>
